module.exports = __webpack_public_path__ + "img/car-back.b87c503e.svg";